// SetupWasteWaterStoreProps

import { create } from "zustand";
import { getFilterColumnManualWasteWater, searchManualVocWater, updateManualWasteWater } from "src/services/waste-water.service";
import { ManualWasteWaterStoreProps } from "./interface/manual-waste-water.interface";
import {
  FilterManualWasteWater,
  RawResponseManualWasteWater,
  ResponseManualWasteWater,
  UpdateManualWasteWater,
} from "src/entity/waste-water/manual-waste-water.entity";
import { WasteWaterEmissionDTO } from "src/entity/waste-water/setup-information.entity";
import { UnitAllEnum, UNITS_ENUM } from "src/entity/common/unit.constant";

export const manualWasteWaterStore = create<ManualWasteWaterStoreProps>((set) => ({
  loadingManageWasteWater: false, // create, update, delete
  loadingWasteWater: false, // search & filter
  dataManualWasteWater: {
    data: [],
    total: 0,
  },
  errorWasteWater: null,
  filterWasteWater: {
    wasteWaterUnit: [],
    area: [],
    emission: [],
    emissionControl: [],
    efficiency: [],
  },
  clearError: (type: string) => {
    set(() => ({ [`${type}`]: null }));
  },
  setError: (type: string, value: string) => {
    set(() => ({ [`${type}`]: value }));
  },

  updateManualWasteWater: async (_id: string, body: UpdateManualWasteWater) => {
    set(() => ({ loadingManageWasteWater: true }));
    try {
      await updateManualWasteWater(_id, body);
      set(() => ({ loadingManageWasteWater: false }));
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManageWasteWater: false, errorWasteWater: message }));
      return message;
    }
  },
  searchManualWasteWater: async (filter: FilterManualWasteWater) => {
    set(() => ({ loadingWasteWater: true }));
    try {
      const res = await searchManualVocWater(filter);

      const rawData = res.data?.data;
      const transformArray: ResponseManualWasteWater[] = [];
      const paramsEmission = filter.emission;
      const isEmissionFilter = Array.isArray(paramsEmission) && paramsEmission.length > 0;
      rawData.data.forEach((item: RawResponseManualWasteWater, index: number) => {
        const cloneEmission = { ...item.emission };
        const listActiveEmission = [];
        for (const key in item.emission) {
          if (item.emission[key as keyof WasteWaterEmissionDTO].active === true) {
            if (isEmissionFilter) {
              if (paramsEmission.includes(key)) listActiveEmission.push(key);
              else delete item.emission[key as keyof typeof item.emission];
            } else listActiveEmission.push(key);
          }
        }

        listActiveEmission.forEach((activeKey) => {
          transformArray.push({
            ...item,
            no: index + 1,
            cloneEmission,
            activeEmission: activeKey.toUpperCase(),
            unit: UnitAllEnum.MG,
            emissionBeforeTreatmentValue: item.emission[activeKey as keyof WasteWaterEmissionDTO].emissionBeforeTreatment ?? 0,
          });
        });
      });

      rawData.data = transformArray;
      set(() => ({ loadingWasteWater: false, dataManualWasteWater: rawData }));
    } catch (err: any) {
      set(() => ({ loadingWasteWater: false, error: err?.message, dataManualWasteWater: { data: [], total: 0 } }));
    }
  },
  getFilterColumnManualWasteWater: async (year: string) => {
    set(() => ({ loadingWasteWater: true }));
    try {
      const res = await getFilterColumnManualWasteWater({ year });
      set(() => ({
        loadingWasteWater: false,
        filterWasteWater: res.data?.data,
      }));
    } catch (err: any) {
      set((state) => ({
        loadingWasteWater: false,
        filterWasteWater: {
          ...state.filterWasteWater,
        },
      }));
    }
  },
}));
